const DeliverTimes = {
  NOW: 'NOW',
  FUTURE: 'FUTURE'
};

export default DeliverTimes;
